import Service, { service } from "@ember/service";
import { bind } from "discourse/lib/decorators";

const ERBOX_TOAST_THEMES = new Set([
  "default",
  "info",
  "success",
  "error",
  "warning",
]);

const ERBOX_TOAST_FALLBACK_ICONS = {
  error: "triangle-exclamation",
  info: "circle-info",
  success: "check",
  warning: "circle-exclamation",
};

export default class ErboxToasts extends Service {
  @service router;
  @service toasts;

  constructor() {
    super(...arguments);
    this.router.on("routeDidChange", this.closeRouteToasts);
  }

  willDestroy() {
    this.router.off("routeDidChange", this.closeRouteToasts);
  }

  show({
    id,
    theme = "default",
    message,
    dismissOnRouteChange = false,
    duration = "long",
    class: toastClass,
    data = {},
    ...options
  } = {}) {
    const resolvedTheme = ERBOX_TOAST_THEMES.has(theme) ? theme : "default";

    if (id) {
      this.close(id);
    }

    return this.toasts.show({
      ...options,
      class: ["erbox-toast", `--${resolvedTheme}`, toastClass]
        .filter(Boolean)
        .join(" "),
      duration,
      data: {
        ...data,
        icon: data.icon ?? ERBOX_TOAST_FALLBACK_ICONS[resolvedTheme],
        message,
        theme: resolvedTheme,
        erboxToastId: id,
        erboxToastDismissOnRouteChange: dismissOnRouteChange,
      },
    });
  }

  info(options = {}) {
    return this.show({ ...options, theme: "info" });
  }

  success(options = {}) {
    return this.show({ ...options, theme: "success" });
  }

  error(options = {}) {
    return this.show({ ...options, theme: "error" });
  }

  warning(options = {}) {
    return this.show({ ...options, theme: "warning" });
  }

  close(id) {
    this.toasts.activeToasts
      .filter((toast) => toast.options.data?.erboxToastId === id)
      .forEach((toast) => this.toasts.close(toast));
  }

  @bind
  closeRouteToasts(transition) {
    if (transition?.isAborted) {
      return;
    }

    this.toasts.activeToasts
      .filter(
        (toast) => toast.options.data?.erboxToastDismissOnRouteChange
      )
      .forEach((toast) => this.toasts.close(toast));
  }
}
